import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  DateRange,
  extractDateRange,
  extractNumber,
  HxCurrencyPipe,
  HxFixedPipe,
  HxMoneyFormatPipe,
  HxReportService,
  HxUiLabelPipe,
  isoDate,
  StatisticsEmployeeSalesModel,
  StoreBasicModel,
  toRouterQueryParams
} from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { subDays, subMonths } from 'date-fns';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-statistics-employee',
    templateUrl: './employee-sales.component.html',
    styleUrls: ['./employee-sales.component.css'],
    imports: [HxDateRangeSelectComponent, FormsModule, HxStoreSelectComponent, NgIf, NgFor, NgClass, RouterLink, HxLoaderComponent, NgbPagination, TranslocoPipe, HxCurrencyPipe, HxUiLabelPipe, HxFixedPipe, HxMoneyFormatPipe]
})
export class EmployeeSalesComponent implements OnInit, OnDestroy {
  sales: StatisticsEmployeeSalesModel[] = [];
  isloading = {
    sales: false,
  };
  params: {
    page: number,
    limit: number,
    date?: DateRange,
    storeId?: number,
  } = { page: 1, limit: 20 };
  pagination = {
    allItemCount: 0
  };
  private sub!: Subscription;

  constructor(
    private reportService: HxReportService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.sub = this.aRoute.queryParamMap.subscribe(async paramMap => {
      this.params.date = extractDateRange('date', paramMap) ?? {from: isoDate(subDays(subMonths(new Date(), 1), 1)), to: isoDate(subDays(new Date(), 1))};
      this.params.limit = extractNumber('limit', paramMap) ?? 20;
      this.params.page = extractNumber('page', paramMap) ?? 1;
      this.params.storeId = extractNumber('storeId', paramMap);
      this.loadEmployeeSales();
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  applyFilters() {
    this.navigate();
  }

  onStoreChanged(store: StoreBasicModel | StoreBasicModel[] | undefined) {
    if (!Array.isArray(store)){
      this.params.storeId = store?.id;
      this.applyFilters();
    }
  }

  pageChanged(event: number) {
    this.params.page = event;
    this.navigate();
  }

  private navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  private async loadEmployeeSales() {
    this.sales = [];
    this.isloading.sales = true;
    try {
      const sales = await this.reportService.getStatisticsEmployeeSales({fromDate: this.params.date.from, toDate: this.params.date.to, page: this.params.page, limit: this.params.limit, storeIds: [this.params.storeId] });
      if (sales.count > 0) {
        this.sales = sales.list;
        this.pagination.allItemCount = sales.count;
      } else {
        this.sales = [];
      }
    } finally {
      this.isloading.sales = false;
    }
  }
}
